var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-container-bottom-control-device image",class:_vm.section,style:(_vm.img()),attrs:{"onError":"this.style.backgroundImage='url('+require('@/assets/images/rooms/empty.jpg')+')'"}})}
var staticRenderFns = []

export { render, staticRenderFns }